export default __webpack_public_path__ + "static/media/Home_IMG.c195aeec.png";